import { render, staticRenderFns } from "./product.related.vue?vue&type=template&id=4ca72e70&"
import script from "./product.related.vue?vue&type=script&lang=js&"
export * from "./product.related.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports